// @ts-nocheck
import React, { useCallback, useMemo } from 'react';
import { GlobalStyles } from '@mui/material';

const AI_HIGHLIGHT_CLASS = 'ai-highlight-attribute';
const AI_HIGHLIGHT_DURATION = 3500;

const getAIHighlightStyles = (theme) => ({
  '@keyframes aiAttributeHighlightPulse': {
    '0%': {
      boxShadow: `0 0 0 0 ${theme?.palette?.other?.aiHighlightShadowBase}`,
      backgroundColor: theme?.palette?.other?.aiHighlightBackgroundBase,
    },
    '15%': {
      boxShadow: `0 0 8px 2px ${theme?.palette?.other?.aiHighlightShadowStrong}`,
      backgroundColor: theme?.palette?.other?.aiHighlightBackgroundStrong,
    },
    '33%': {
      boxShadow: '0 0 0 0 transparent',
      backgroundColor: theme?.palette?.other?.aiHighlightBackgroundFaint,
    },
    '48%': {
      boxShadow: `0 0 8px 2px ${theme?.palette?.other?.aiHighlightShadowMedium}`,
      backgroundColor: theme?.palette?.other?.aiHighlightBackgroundMedium,
    },
    '66%': {
      boxShadow: '0 0 0 0 transparent',
      backgroundColor: theme?.palette?.other?.aiHighlightBackgroundFaint,
    },
    '81%': {
      boxShadow: `0 0 6px 1px ${theme?.palette?.other?.aiHighlightShadowSoft}`,
      backgroundColor: theme?.palette?.other?.aiHighlightBackgroundSoft,
    },
    '100%': {
      boxShadow: '0 0 0 0 transparent',
      backgroundColor: 'transparent',
    },
  },
  [`.${AI_HIGHLIGHT_CLASS}`]: {
    animation: `aiAttributeHighlightPulse ${AI_HIGHLIGHT_DURATION}ms ease-in-out`,
    borderRadius: '4px',
  },
});

const useAIAttributeHighlight = () => {
  const aiHighlightStyles = useMemo(() => {
    return <GlobalStyles styles={getAIHighlightStyles} />;
  }, []);

  const highlightElement = useCallback((element) => {
    if (!element) {
      return;
    }

    element.classList.remove(AI_HIGHLIGHT_CLASS);

    // Force reflow via rAF so re-adding the class restarts the animation.
    requestAnimationFrame(() => {
      element.classList.add(AI_HIGHLIGHT_CLASS);

      const cleanup = () => {
        element.classList.remove(AI_HIGHLIGHT_CLASS);
      };

      element.addEventListener('animationend', cleanup, { once: true });
      // Fallback timeout.
      setTimeout(cleanup, AI_HIGHLIGHT_DURATION + 100);
    });
  }, []);

  return { aiHighlightStyles, highlightElement };
};

export default useAIAttributeHighlight;
